export default "__VITE_ASSET__GE7hKWlN__"